import { useRef, useEffect } from 'react';

import ButtonMailto from "../../atoms/button/button-mail-to";
import ContactFormBox from '../../components/contact-box/contact-box.component';

import useScrollListener from "../../hooks/useScrollListener";


import Footer from "../../components/footer/footer.component";
 import { 
	ContactUsRouteContainer, 
	ContactUsContainer
 } from "./contactus.styles";
 
 
 const ContactUs = ({ onScroll }) => {
	 const contentRef = useScrollListener(onScroll);
	 const contactRef = useRef(null); // Ref for Contact section

	const scrollToContact = () => {
		// Smoothly scroll to the Contact section
		if (contactRef.current) {
			contactRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	};

	// Check for scroll flag in sessionStorage on load
	useEffect(() => {
		if (sessionStorage.getItem('scrollToContact') === 'true') {
			scrollToContact();
			sessionStorage.removeItem('scrollToContact'); // Reset the flag after scrolling
		}
	}, []);
 
	 return (
		 <ContactUsRouteContainer  ref={contentRef}>
				 <ContactUsContainer theme={{ hoverBg: 'white', hoverBrd: 'black' }}>
					 <div className='about-info' >
						 <h2>CONTACT US</h2>
						 <p>Hey there! We're so glad you're considering reaching out to us at Tree.</p>
						 <p>Whether you have a question, need some advice, or are ready to kickstart your next big ecommerce project, we’re here to help.</p>
						 <p>By contacting us, you’re making a smart move toward growing your business.</p>
						 <p>At Tree, we’re all about turning your ideas into reality, helping your brand flourish in the digital world.</p>
						 <p>We believe in simple, honest communication, and we're eager to chat about how we can support you.</p>
						 <p>So go ahead, drop us a message! Let's talk about your vision and how we can make it happen—together.</p>
						 <p>Ready to grow? We're just a message away. 🌿</p>

						 <p>Social Media: @treegotyou</p>
						 <p>Email: treegotyou@gmail.com</p>

						 {/* <div className="google-form-box"> */}
						 	{/* <iframe 
								src="https://docs.google.com/forms/d/e/1FAIpQLSfRv5tTWKKWP8WHQ_dB7hxcGzDOwgmQinKbAvPV82g_iAZe_g/viewform?embedded=true" 
								width="100%" 
								minwidth="100%"
								height="1320" 
								frameborder="0" 
								marginheight="0" 
								marginwidth="0"
								margin="0"
								padding="0"
							>Loading…</iframe> */}
						 {/* </div> */}
						 
						 {/* <Button text="CONTACT US" loc="/company/contactus" /> */}
						 
					 </div>
					 <div ref={contactRef}>
						<ContactFormBox whatContactForm={<div class="klaviyo-form-R3vFLg"></div>} />
					</div>
					 {/* <div class="klaviyo-form-RaLuFy"></div> */}
					 <Footer />
				 </ContactUsContainer>
		 </ContactUsRouteContainer>
	 )
 }
 
 export default ContactUs;










// const ContactUs = () => {
	

// 	return(
// 		<ContactUsRouteContainer>
// 				<ContactUsContainer theme={{ hoverBg: 'white', hoverBrd: 'black' }}>
// 					<div className='about-info' >
					
// 						<h1>Get in Touch with Tree: Your Digital Partner</h1>
// 						<p>Ready to take your digital venture to new heights?</p>
// 						<p>At Tree, we’re not just about providing resources; we’re your partners in success.</p>
// 						<p>Whether you’re at the inception stage or aiming for the pinnacle of digital potential, we’ve got your back.</p>

// 						<ButtonMailto label="EMAIL US" mailto="mailto:treegotyou@gmail.com" />
						
// 						<ul>
// 							<h1>Why Contact Tree?</h1>
// 							<li><b>Personified Advice</b>: Your journey is unique, and so is our guidance. We don’t believe in one-size-fits-all solutions. When you reach out to Tree, you get advice tailored to your business, your goals, and your vision.</li>
// 							{/* <li><b>Professional Assistance</b>: Need a hand in setting up your online empire? From business setup to digital marketing strategies, we’re the professionals you need.</li> */}
// 							<li><b>Professional Assistance</b>: Need a hand in setting up your online empire? Our team of experts is ready to roll up their sleeves. From business setup to digital marketing strategies, we’re the professionals you need.</li>
// 							<li><b>Availability</b>: We get it – inspiration strikes at any time. That’s why we’re at your service from 12am to 11:59pm, Monday to Saturday. Your questions, concerns, or eureka moments – we’re here for it all.</li>
// 						</ul>
						
// 						<h1>Ready to dive into the digital journey with Tree?</h1>

// 						{/* <Button func={openGmail} text="" /> */}
// 						<ButtonMailto label="GET IN TOUCH WITH US" mailto="mailto:treegotyou@gmail.com" />

// 						<p>We offer a free consultation to get the ball rolling.</p>
// 						<p>No strings attached – just pure, personalized advice waiting for you.</p>
// 						<span></span>
// 						<p>Share your vision, your challenges, or simply say hello.</p>
// 						<p>Our team will get back to you with personalized insights and the next steps to kickstart your digital success.</p>
						
// 						<h1>Hire Us</h1>
// 						<p>Ready to bring in the experts?</p> 
// 						<p>Whether it’s setting up your digital storefront or crafting a marketing strategy that resonates, we’re here to make it happen.</p>
// 						<p>Hire Tree, and let’s turn your digital dreams into reality.</p>

// 						{/* <Button func={openGmail} text="HIRE US" /> */}
// 						<ButtonMailto label="HIRE US" mailto="mailto:treegotyou@gmail.com" />

// 						<p>Your journey to digital success starts with a single message.</p>
// 						<p>Contact Tree today, and let’s embark on this exciting adventure together.</p>
// 						<p>The digital revolution awaits – are you ready?</p>

// 						<span></span>
// 						<p>At Tree, we’re not just a contact; we’re your partners in digital triumph.</p>
// 					</div>
// 				</ContactUsContainer>
// 		</ContactUsRouteContainer>
// 	);
// }

// export default ContactUs;